//Conforme cálculos no HC
export const calcConsideredWeight = (
  volume: number,
  grossWeight: number,
  isIA: boolean = false,
) => {
  const COEFFICIENT_CUBED_WEIGHT_IA = 6000;
  const COEFFICIENT_CUBED_WEIGHT_OTHERS = 1000.0;

  const COEFFICIENT_CUBED_WEIGHT = isIA
    ? COEFFICIENT_CUBED_WEIGHT_IA
    : COEFFICIENT_CUBED_WEIGHT_OTHERS;

  const cubeWeight = +volume * COEFFICIENT_CUBED_WEIGHT;

  const consideredWeight = Math.max(cubeWeight, +grossWeight);
  const consideredWeightToReturn = isIA
    ? consideredWeight
    : consideredWeight / COEFFICIENT_CUBED_WEIGHT;

  return {
    consideredWeight: Number.parseFloat(consideredWeightToReturn.toFixed(3)),
    cubeWeight: cubeWeight,
  };
};
